import React from 'react';
import { motion } from "framer-motion";
import {
  BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Cell
} from 'recharts';
import { v4 as uuidv4 } from 'uuid';
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white shadow px-2 py-1 text-sm border border-gray-200 rounded">
        {payload[0].name}: <strong>{payload[0].value}</strong>
      </div>
    );
  }
  return null;
};

const JobStatusChart = ({ dashboardDetails }) => {

  const data = [
    { name: 'Completed', value: dashboardDetails?.[0]?.count, color: 'green' },
    { name: 'In Progress', value: dashboardDetails?.[1]?.count, color: '#4338CA' },
    { name: 'Pending', value: dashboardDetails?.[2]?.count, color: '#FBBF24' },
  ];

  return (

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      whileHover={{ scale: 1.05, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)" }}
      whileTap={{ scale: 0.95 }}
      className="rounded-lg bg-[#fafafb] shadow-lg p-4 w-full max-w-lg">
      <h3 className="text-gray-800 font-semibold mb-4">Service Status</h3>

      <div className="grid grid-cols-3 mb-2 text-sm font-semibold">
        <div className="text-green-700 text-center">Completed<br /><span className="text-lg">{data[0].value}</span></div>
        <div className="text-[#4338CA] text-center">In Progress<br /><span className="text-lg">{data[1].value}</span></div>
        <div className="text-[#FBBF24] text-center">Pending<br /><span className="text-lg">{data[2].value}</span></div>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={160}>
        <BarChart data={data} barCategoryGap={40}>
          <XAxis dataKey="name" hide />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="value" barSize={80} radius={[6, 6, 0, 0]}>
            {data?.map((entry) => (
              <Cell key={uuidv4()} fill={entry?.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Legend */}
      <div className="flex justify-center gap-9 mt-4 text-sm text-gray-600">
        {data?.map((item) => (
          <div key={uuidv4()} className="flex items-center gap-1">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: item?.color }}></span>
            {item?.name}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default JobStatusChart;
